export const SOCCER_MARKET_BUCKET_ORDER = [
  'moneyline',
  'spread',
  'total',
  'exact_score',
  'first_half',
  'second_half',
  'corners',
  'player_props',
  'other',
] as const;
export type SoccerMarketBucket = (typeof SOCCER_MARKET_BUCKET_ORDER)[number];
const RANK = new Map(SOCCER_MARKET_BUCKET_ORDER.map((b, i) => [b, i]));
/** Rank for sorting; unknown/unset → Number.MAX_SAFE_INTEGER (sinks to bottom). */
export function soccerMarketRank(b?: string | null): number {
  const rank = b ? RANK.get(b as SoccerMarketBucket) : undefined;
  return rank ?? Number.MAX_SAFE_INTEGER;
}
